export enum SummaryBoxColorScheme {
  Default = 'default',
  LightBlue = 'light-blue',
  DarkBlue = 'dark-blue',
  Green = 'green',
  DarkGreen = 'dark-green',
  Orange = 'orange',
  Pink = 'pink',
  White = 'white',
  WritingLegendsBlue = 'wl-blue',
}

export const SummaryBoxColorSchemeClasses: Record<
  SummaryBoxColorScheme,
  {
    header: string
    stats: string
    dividerBg: string
    dividerBorder: string
  }
> = {
  [SummaryBoxColorScheme.Default]: {
    header: 'bg-dusty-black-300',
    stats: 'bg-dusty-black-100',
    dividerBg: 'bg-white',
    dividerBorder: 'border-white',
  },
  [SummaryBoxColorScheme.LightBlue]: {
    header: 'bg-oceany-blue-300',
    stats: 'bg-oceany-blue-100',
    dividerBg: 'bg-white',
    dividerBorder: 'border-white',
  },
  [SummaryBoxColorScheme.DarkBlue]: {
    header: 'bg-wl-blue-250',
    stats: 'bg-wl-blue-100',
    dividerBg: 'bg-white',
    dividerBorder: 'border-white',
  },
  [SummaryBoxColorScheme.Green]: {
    header: 'bg-grapey-green-300',
    stats: 'bg-grapey-green-100',
    dividerBg: 'bg-white',
    dividerBorder: 'border-white',
  },
  [SummaryBoxColorScheme.DarkGreen]: {
    header: 'bg-forest-green-300',
    stats: 'bg-forest-green-100',
    dividerBg: 'bg-white',
    dividerBorder: 'border-white',
  },
  [SummaryBoxColorScheme.Orange]: {
    header: 'bg-juicy-orange-300',
    stats: 'bg-juicy-orange-100',
    dividerBg: 'bg-white',
    dividerBorder: 'border-white',
  },
  [SummaryBoxColorScheme.Pink]: {
    header: 'bg-purply-pink-300',
    stats: 'bg-purply-pink-100',
    dividerBg: 'bg-white',
    dividerBorder: 'border-white',
  },
  [SummaryBoxColorScheme.White]: {
    header: 'bg-white',
    stats: 'bg-white',
    dividerBg: 'bg-white',
    dividerBorder: 'border-white',
  },
  [SummaryBoxColorScheme.WritingLegendsBlue]: {
    header: 'bg-wl-blue-300',
    stats: 'bg-white',
    dividerBg: 'bg-wl-blue-300',
    dividerBorder: 'border-wl-blue-300',
  },
}

export enum SummaryBoxType {
  Single = 'single',
  Double = 'double',
  Triple = 'triple',
  Many = 'many',
}

export const SummaryBoxTypeClasses = {
  [SummaryBoxType.Single]: {
    statWrapper: 'flex grow flex-col',
    statBox: 'flex grow flex-col justify-center py-3 px-0',
    statTitle: 'text-3xl',
  },
  [SummaryBoxType.Double]: {
    statWrapper: 'flex grow flex-col',
    statBox: 'grow py-3 px-0',
    statTitle: 'text-3xl',
  },
  [SummaryBoxType.Triple]: {
    statWrapper: 'flex grow flex-row flex-wrap',
    statBox: 'relative grow w-1/2 py-3 px-0',
    statTitle: 'text-3xl',
  },
  [SummaryBoxType.Many]: {
    statWrapper: 'flex grow flex-col flex-nowrap',
    statBox: 'flex grow justify-between items-center w-auto p-0',
    statTitle: 'order-2 text-xl',
  },
}
